// this component is written using class based component.

import React from 'react'
import UserClass from './UserClass'

const About = () => {
  return (
    <div>
      <div>About Us</div>
      <UserClass  />
    </div>
  )
}

export default About
